import CollapsableTagView from "../UI/CollapsableTagView";
import { TbGavel } from "react-icons/tb";

const PresaleContributionCard = ({ idoDetailArray = [] }) => {
    const itemRenderer = (item, i) => {
        return (
            <div
                key={i}
                className={`rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3 ${
                    item.colspan || ""
                }`}
            >
                <span className="text-kad-gradient size-sm">{item.cap}</span>
                <span> {item.name}</span>
                <span className="size-sm font-normal">{item.value}</span>
            </div>
        );
    };
    return (
        <CollapsableTagView
            icon={<TbGavel />}
            tagHeader="Contributions"
            tagList={idoDetailArray}
            itemRenderer={itemRenderer}
        />
    );
};
export default PresaleContributionCard;
